import { COLLABORATION_TAG, HISTORIC_TAG, PASTE_TAG, CUT_TAG } from "lexical";
import type { UpdateOrigin } from "../react/contract";

export type { UpdateOrigin };

/** Marks an accepted programmatic edit so hosts can tell it apart from typing. */
export const PROGRAMMATIC_TAG = "z-editor-programmatic";

/**
 * Marks the update in which a shared editor runs its transforms over what a merge touched. It is a
 * consequence of other people's edits, not an edit of this person's.
 */
export const MERGE_REPAIR_TAG = "z-editor-merge-repair";

export function originFromTags(tags: ReadonlySet<string>): UpdateOrigin {
  if (tags.has(COLLABORATION_TAG) || tags.has(MERGE_REPAIR_TAG)) return "remote";
  if (tags.has(PROGRAMMATIC_TAG)) return "programmatic";
  if (tags.has(HISTORIC_TAG)) return "history";
  if (tags.has(PASTE_TAG) || tags.has(CUT_TAG)) return "clipboard";
  return "user";
}
